import axios from "axios";
import { getSession, setSession, setSessionJSON } from "./SessionUtils";
import keycloak from "../ui/components/keyclock";

// Axios instance with interceptor to attach Keycloak token
const api = axios.create();

api.interceptors.request.use(async (config) => {
  try {
    if (keycloak.isTokenExpired()) {
      await keycloak.updateToken(30);
      setSession("KC_TOKEN", keycloak.token);
    }

    const token = keycloak.token;
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch (error) {
    console.error("Failed to refresh token:", error);
    setSessionJSON("login-data", "");
    setSession("KC_TOKEN", "");
    window.location.href = "/store/";
    throw new Error("Session expired. Please login again.");
  }
  return config;
});

// Response interceptor to handle 401 errors (unauthorized)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.error("Unauthorized - Token is invalid or expired");
      // Clear session data
      setSessionJSON("login-data", "");
      setSession("KC_TOKEN", "");
      // Redirect to login page
      window.location.href = "/store/";
      return Promise.reject(new Error("Session expired. Please login again."));
    }
    return Promise.reject(error);
  }
);

export const apiCall = async (method, url, data = null) => {
  try {
    const response = await api({
      method,
      url,
      data,
    });
    return response.data; // Return the response data
  } catch (error) {
    console.error("API call error:", error);
    throw new Error(error.response?.data?.message ||error.response?.data|| "API call failed"); // Throw error with message
  }
};
